<div class="text-center">
  <mat-form-field appearance="outline" class="w-full-important">
    <input matInput
           [placeholder]="placeholder"
           [matAutocomplete]="auto"
           [(ngModel)]="text"
           (input)="filterOptions(text)"
           [required]="required"
           [disabled]="disabled"
           #firstNameInput>
  </mat-form-field>
  <mat-autocomplete #auto="matAutocomplete" appearance="outline">
    <mat-option *ngFor="let opt of filteredOptions" [value]="opt.name" (click)="check(opt)" [disabled]="disabled">
      <span>{{ opt.name }}</span>
    </mat-option>
  </mat-autocomplete>
</div>



